<loader-pane-fragment [trace]="mySchedule ? traceNames.viewMySchedule : traceNames.viewOnSiteScheduleTimeline"></loader-pane-fragment>
  <div class="schedule_panel timeline" *ngIf="multiTimeline">
  <div class="action_head">
      <div style="flex:1"></div>
      <div class="controler">
          <icon class="mobile" [ngClass]="{active: !!filtersCount }" (click)="openFilters.emit()" icon="filter_24px"></icon>
          <div style="flex:1"></div>
          <div *ngIf="mySchedule" (click)="doPrint()"><icon matIcon="print"></icon></div>
          <div class="view_mode">
              <icon [ngClass]="{active: timelineMode == 'multiple'}" (click)="toggleView('multiple')" icon="column_multi_24px"></icon>
              <icon [ngClass]="{active: timelineMode == 'single'}" (click)="toggleView('single')" icon="column_single_24px"></icon>
          </div>
          <icon class="view_opt" [matMenuTriggerFor]="viewOptions" matIcon="more_vert"></icon>
          <mat-menu #viewOptions="matMenu" xPosition="before">
              <div class="heading">VIEW</div>
              <button mat-menu-item [ngClass]="{active: detailedMode}" (click)="detailedMode = true">Detailed</button>
              <button mat-menu-item [ngClass]="{active:!detailedMode}" (click)="detailedMode = false">Condensed</button>
              <ng-container *ngIf="timelineMode=='multiple'">
                <hr class="mobile"/>
                <button mat-menu-item class="mobile" (click)="toggleAll('expand')">Expand all programs</button>
                <button mat-menu-item class="mobile" (click)="toggleAll('collapse')">Collapse all programs</button>
              </ng-container>
          </mat-menu>
      </div>
  </div>

  <div class="schedule_body">
    <ng-container *ngIf="timelineMode==='multiple'">
    <expandable-bar-wrapper 
      *ngFor="let timeline of multiTimeline; trackBy: trackById; index as idx; first as first; last as last;"
      [ngClass]="{first: first, last: last}"
      [header]="timeline.date | date:'EEEE d MMMM y'">
      <div class="timeline_items multiple">
        <ng-container *ngFor="let p of timeline.programs; trackBy: trackById; index as k">
          <div *ngIf="!p" class="not_found">No programs and sessions</div>
          <multi-timeline-column *ngIf="p && (!p.venueId || currentEvent.venues[p.venueId])"
            [title]="p.title"
            [location]="p.location"
            [venue]="currentEvent.venues[p.venueId]?.venue"
            [address]="currentEvent.venues[p.venueId]?.address"
            [programLabels]="p.labels"
            [standalone]="p.subType.includes('standalone')"
            [labelTemplate]="labelMaps.program_labels"
            [collapseObject]="timelineViews"
            [collapseStateId]="p.scheduleId"
            [detailedMode]="detailedMode"
            (openProgram)="emitProgramDetail.emit({ scheduleId: p.scheduleId })"
          >
            <div class="not_found" *ngIf="!p.sessions.length">No sessions or activities</div>
            <ng-container *ngFor="let session of p.sessions; first as first; last as last; index as index; trackBy: trackById">
              <timeline-item
                *ngIf="{ start: !!first ? session.start || session.time : { session: session, priorSession: p.sessions[index-1] } | timelineStart } as vars"
                [start]="vars.start"
                [hideDot]="!vars.start && !last"
                [end]="session.end"
                [first]="first"
                [last]="last"
                [link]="true"
                [standalone]="session.isStandalone"
                [title]="session.title"
                [condensedPerformers]="true"
                [description]="session.description"
                [labelMap]="detailedMode && session.type === 'activity' ? labelMaps.activity_labels : labelMaps.session_labels"
                [labelIds]="detailedMode && session.labels"
                [tagData]="tagMap[session.id]"
                [performers]="detailedMode && session.type !== 'activity' && performers ? performers : null"
                [performerIds]="detailedMode && session.type !== 'activity' && session.performerIds ? session.performerIds : []"
                [type]="session.type"
                [activityIncomplete]="session.type === 'activity' && !session.completed"
                [activityComplete]="session.completed"
                [publicLinks]="session.publicLinks"
                [performerRoleIds]="session['performerRoles']"
                [performerRoles]="performerRoles"
                [multi]="true"
                (selectProgram)="openProgram($event, session.program_scheduleId)"
                (selectItem)="emitBrickDetail.emit(session)"
              ></timeline-item>
            </ng-container>
        </multi-timeline-column>
        </ng-container>
      </div>          
    </expandable-bar-wrapper>
  </ng-container>
  <ng-container *ngIf="timelineMode=='single'">
    <expandable-bar-wrapper 
    *ngFor="let timeline of singleTimeline; trackBy: trackBySingleTimeline; index as idx; first as first; last as last;"
    [ngClass]="{first: first, last: last}"
    [header]="timeline.date | date:'EEEE d MMMM y'">
      <single-timeline 
        [singleTimeline]="timeline"
        [detailedMode]="detailedMode"
        [performers]="currentEvent.performers"
        [sponsors]="currentEvent.sponsors"
        [sponsorTypes]="sponsorTypes"
        [labelMaps]="labelMaps"
        [venues]="currentEvent?.venues"
        [performerRoles]="performerRoles"
        [condensedPerformers]="true"
        [tagMap]="tagMap"
        (emitBrickDetail)="emitBrickDetail.emit($event)"
        (openProgramEmitter)="openProgramView($event)"
      ></single-timeline>
    </expandable-bar-wrapper>
  </ng-container>
</div>
